export var NumberFormat;
(function (NumberFormat) {
    NumberFormat[NumberFormat["General"] = 0] = "General";
    NumberFormat[NumberFormat["Number"] = 1] = "Number";
    NumberFormat[NumberFormat["FixedPoint"] = 2] = "FixedPoint";
    NumberFormat[NumberFormat["Currency"] = 3] = "Currency";
    NumberFormat[NumberFormat["Percent"] = 4] = "Percent";
    NumberFormat[NumberFormat["Other"] = 5] = "Other";
})(NumberFormat || (NumberFormat = {}));
;
